<template>
  <div>
    <div>
      <table
        class="table m-auto"
        @click="
          $store.getters.isPlaying ? confirm_exit() : $bvModal.show('testmodal')
        "
      >
        <tbody>
          <tr v-for="(h, i) in th" :key="h">
            <td>{{ h }}</td>
            <td>{{ td_data[td[i]] }}</td>
            <td>
              <md-icon :style="`color:${color(td_data[td[i]])}`">{{
                validate(td_data[td[i]])
              }}</md-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
//  import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "table-input-component",
  mixins: [inputComponentMixin],
  components: {},
  data() {
    return {
      td_data: {}
    };
  },
  async mounted() {
    for (var obj in this.td) {
      this.td_data[this.td[obj]] = this.defaultlist[obj];
      this.$store.commit("setParam", {
        param: this.td[obj],
        value: parseInt(this.defaultlist[obj])
      });
    }

    Bus.$on("value-changed", async () => {
      for (var obj in this.td) {
        this.td_data[this.td[obj]] = this.$store.getters.testParams[
          this.td[obj]
        ];
        this.td_data = Object.assign({}, this.td_data);
      }
    });
  },
  computed: {
    header() {
      return this.attributes.header ? this.attributes.header : "";
    },
    th() {
      if (this.attributes.th === undefined) return [];
      else return this.attributes.th.split("|");
    },
    td() {
      if (this.attributes.td === undefined) return [];
      else return this.attributes.td.split("|");
    },
    defaultlist() {
      if (this.attributes.defaultlist === undefined) return [];
      else return this.attributes.defaultlist.split("|");
    }
  },
  methods: {
    validate(value) {
      return value == undefined ? "error_outline" : "check_circle_outline";
    },
    color(value) {
      return value == undefined ? "red" : "green";
    }
  }
};
</script>
<style scoped>
tr:hover {
  background-color: #f8f8f8;
}
.d-flex {
  display: flex;
  width: 100%;
}
.justify-content-center {
  justify-content: center;
}

.button-container .mt-3 {
  margin-top: 3rem;
}
</style>
